module.exports = __webpack_public_path__ + "static/media/layers.e7df67c3.svg";